<template>
    <div>
        <div class="content">
            <!--<div class="logo"></div>-->
            <div class="maanshanLogo"></div>
            <!--登录方式1-->
            <div v-if="LoginMethod==1">
                <Form ref="FormInlinePhone" :model="FormValidate" :rules="RuleValidate">
                    <FormItem prop="PhoneNum">
                        <Input type="text" v-model="FormValidate.PhoneNum" placeholder="填写手机号码"  size="large" />
                        <SendMsg class="sendMsg"  :fn="GetValidCode" :deftext="'获取验证码'" ref='btn' :second='60'></SendMsg>
                    </FormItem>
                    <FormItem prop="PhoneVaild">
                        <Input type="text" v-model="FormValidate.PhoneVaild" placeholder="填写短信验证码" size="large" />
                    </FormItem>
                    <FormItem>
                        <Button type="primary" long @click="Login('FormInlinePhone')">{{LoginTxt}}</Button>
                    </FormItem>
                </Form>
            </div>
            <!--登录方式2-->
            <div class="loginForm" v-else-if="LoginMethod==2">
                <Form ref="FormInlinePassword" :model="FormValidate" :rules="RuleValidate">
                    <FormItem prop="UserName">
                        <Input v-model="FormValidate.UserName" placeholder="请输入账号" size="large"/>
                    </FormItem>
                    <FormItem prop="Password">
                        <Input v-model="FormValidate.Password" placeholder="请输入密码" type="password" size="large"/>
                    </FormItem>
                    <FormItem>
                        <Button type="primary" long @click="Login('FormInlinePassword')">{{LoginTxt}}</Button>
                    </FormItem>
                </Form>
            </div>
            <!--登录方式3-->
            <div v-else-if="LoginMethod==3">
                <iframe :src="QRcode" style="height:100%;min-height:400px;width:100%;top:-30px;"></iframe>
            </div>
        </div>
    </div>
</template>

<script>
    import SendMsg from '../components/BaseEllipsis/SendMsg.vue'
    import md5 from 'blueimp-md5'
    import Vue from 'vue'
    Vue.prototype.$md5=md5;
    export default {
        name: "Login",
        components:{
            SendMsg
        },
        props:["LoginMethod"],
        data () {
            return {
                FormValidate:{
                    UserName: "",
                    Password: "",
                    PhoneNum:"",
                    PhoneVaild:""
                },
                RuleValidate: {
                    UserName: [{ required: true, message: '账号不能为空', trigger: 'blur' }],
                    Password: [{ required: true, message: '密码不能为空', trigger: 'blur' }],
                    PhoneNum: [{ required: true, trigger: 'blur',validator: function(rule, value, callback){
                        let reg = /^1[3456789]\d{9}$/;
                        if (value == '') {return callback('请填写手机号');}
                        else if (!reg.test(value)) {return callback('手机号码格式错误');}
                        else {return callback();}
                     }}],
                    PhoneVaild:[{ required: true, message: '请填写验证码', trigger: 'blur' }]
                },
                LoginTxt:"登录",
                QRcode:"",
                Sending:false,
            };
        },
        mounted () {
            // this.GetQRcodeRUL();//生成二维码
            // let timer=setInterval(this.GetQRcodeRUL,20000);
            // this.$once('hook:beforeDestroy', () => {
            //     clearInterval(timer);
            // });
        },
        methods: {
            GetQRcodeRUL(){
                let that=this;
                this.OutApi("api/wechat/GetLoginQRCodeUrl", {UserId:""},"get").then(function (result) {
                    if(!result) return false;
                    that.QRcode=result;
                });
            },
            GetValidCode:function(){
                if(this.Sending) return;
                let _self=this;
                if(_self.FormValidate.PhoneNum=="") {return;}
                if(_self.FormValidate.PhoneNum.split("").length<=10){_self.$Message.error("请输入正确的手机号");return;}
                _self.$refs.btn.run();   //开始倒计时
                _self.Sending=true; //禁用重新发送按钮
                setTimeout(function(){_self.Sending=false}, 60000);
                _self.$store.commit("GetValidCode",_self.FormValidate.PhoneNum);
            },
            Valid(name){
                let res=false;
                this.$refs[name].validate((valid) => {
                    if (valid) {res = true;}
                });
                return res;
            },
            Login (name,token,data={}) {
                let that=this;
                if(that.LoginTxt == "正在登录中..."){return false;}
                let hasValid;
                switch (name) {
                    case "UnionId":
                        data={
                            S_Token:token,
                            DengLuFangShi:6
                        };
                        break;
                    case "FormInlinePhone":
                        that.$store.commit("PhoneSecret", that.FormValidate.PhoneNum);
                        data={
                            S_UserPhone:that.$store.state.PhoneSecret.SendObj,
                            S_YZM:that.FormValidate.PhoneVaild,
                            DengLuFangShi:1
                        };
                        hasValid=that.Valid(name);
                        if(!hasValid) {return false}
                        that.LoginTxt = "正在登录中...";
                        break;
                    case "FormInlinePassword":
                        var mixPass=that.FormValidate.UserName+"+"+that.FormValidate.Password;
                        var _password=that.$md5(mixPass);
                        //console.log(mixPass)
                        data={
                            S_UserFlag:that.FormValidate.UserName,
                            S_ZhuCeFangShi:_password,
                            DengLuFangShi:3
                        };
                        hasValid=that.Valid(name);
                        if(!hasValid) {return false}
                        that.LoginTxt = "正在登录中...";
                        break;
                    default:
                        break;
                }
                that.InApi("api/wangting/UserInfo/Login", data,"post").then(response => {
                    if(!response) return false;
                    let res=JSON.parse(response);
                    that.LoginTxt = "登录";
                    if (res.ReturnCode == false) {
                        that.$Message.error(res.ReturnMessage);
                        that.$store.commit("CanShowModal",true);
                        return false;
                    }
                    localStorage.setItem('token', res.Token);
                    localStorage.setItem('S_UserFlag',res.ReturnData[0].S_UserFlag);
                    localStorage.setItem('S_UserPhone',res.ReturnData[0].S_UserPhone);
                    localStorage.setItem('G_Roles',res.ReturnData[0].G_Roles);
                    that.$emit('ChangeUserName',res.ReturnData[0].S_UserFlag);
                    that.$emit('CancelModal');
                    that.$store.commit("ChangeBaseLayoutActive","PersonalBusinessList");
                    that.$store.commit("GetSelectRole",{_I_Type:2});//获取实名认证信息
                    //如果没有openid则跳关注
                    if(res.ReturnData[0].S_OpenID==""){
                        that.$emit('ShowWechatModal',true);
                        return false;
                    }
                    //曾经微信公众号注册过但没完善信息的跳转
                    if(!res.ReturnData[0].S_UserFlag){
                        that.$router.push({path: 'AccountManagementList',query:{TabName:"addUserInfo"}});
                    }else if(!res.ReturnData[0].S_UserPhone){
                        that.$router.push({path: 'AccountManagementList',query:{TabName:"changePhoneNumber"}});
                    }
                    that.LocalStorage();
                });
            },
            LocalStorage () {
                this.$store.state.GetSelectRole.CompanyRoles=[];
                this.$store.commit("GetBaseData",2);
                this.$store.commit("GetScid");
            },
            ResetFields(){
                let that=this;
                that.$nextTick(function(){
                    that.LoginMethod==1?that.$refs["FormInlinePhone"].resetFields():that.$refs["FormInlinePassword"].resetFields();
                    that.LoginTxt = "登录";
                });
            }
        }
    };
</script>
<style scoped>
    .logo{width:100%;height:30px;background: url("../assets/Img/pic-logo.png") left no-repeat;}
    .maanshanLogo{width:80%;height:100px;background: url("../assets/Img/maanshan.png") center no-repeat;background-size: contain;margin:0 auto;}
    .sendMsg{position: absolute;right: 0;top:4px}
    .sendMsg:hover{
        cursor: pointer;
    }
</style>>
